import { render } from "./DTimeTravel.vue?vue&type=template&id=70b90003"
import script from "./DTimeTravel.vue?vue&type=script&lang=js"
export * from "./DTimeTravel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__